module.exports = __webpack_public_path__ + "static/media/site-design.c59d6853.jpg";